export default "__VITE_ASSET__557be718__"